"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function defaultCanFillElement() {
    return true;
}
function defaultShowAction(element) {
    if (typeof element.attributes["data-old-border"] === "undefined") {
        element.attributes["data-old-border"] = element.style.border;
    }
    var oldBorder = element.attributes["data-old-border"];
    element.style.border = "1px solid red";
    setTimeout(function () {
        element.style.border = oldBorder;
    }, 500);
}
function matchesSelector(el, selector) {
    return el.matches(selector);
}
function formFiller() {
    var document = window.document;
    var defaultMapElements = {
        textarea: fillTextElement,
        'input[type="text"]': fillTextElement,
        'input[type="password"]': fillTextElement,
        'input[type="number"]': fillNumberElement,
        select: fillSelect,
        'input[type="radio"]': fillRadio,
        'input[type="checkbox"]': fillCheckbox,
        'input[type="email"]': fillEmail,
        "input:not([type])": fillTextElement
    };
    var config = {
        elementMapTypes: defaultMapElements,
        showAction: defaultShowAction,
        canFillElement: defaultCanFillElement,
        maxNbTries: 10,
        logger: console,
        randomizer: null
    };
    function formFillerGremlin() {
        if (!config.randomizer) {
            throw new exceptions_1.RandomizerRequiredException();
        }
        var elementTypes = [];
        for (var key in config.elementMapTypes) {
            if (config.elementMapTypes.hasOwnProperty(key)) {
                elementTypes.push(key);
            }
        }
        var element;
        var nbTries = 0;
        do {
            var elements = document.querySelectorAll(elementTypes.join(","));
            if (elements.length === 0) {
                return false;
            }
            element = config.randomizer.pick(Array.from(elements));
            nbTries++;
            if (nbTries > config.maxNbTries) {
                return false;
            }
        } while (!element || !config.canFillElement(element));
        var elementType;
        for (var selector in config.elementMapTypes) {
            if (matchesSelector(element, selector)) {
                elementType = selector;
                break;
            }
        }
        if (!elementType || !(elementType in config.elementMapTypes)) {
            var selectorsStr = Object.keys(config.elementMapTypes).join(", ");
            throw new Error("Selectors \"" + selectorsStr + "\" did not match");
        }
        var value = config.elementMapTypes[elementType](element);
        if (typeof config.showAction === "function") {
            config.showAction(element);
        }
        if (config.logger && typeof config.logger.log == "function") {
            config.logger.log("gremlin", "formFiller", "input", value, "in", element);
        }
    }
    function fillTextElement(element) {
        if (config.randomizer === null) {
            return undefined;
        }
        var character = config.randomizer.character();
        element.value += character;
        return character;
    }
    function fillNumberElement(element) {
        if (config.randomizer === null) {
            return undefined;
        }
        var number = config.randomizer.character({ pool: "0123456789" });
        element.value += number;
        return number;
    }
    function fillSelect(element) {
        var options = element.querySelectorAll("option");
        if (options.length === 0 || config.randomizer === null) {
            return;
        }
        var randomOption = config.randomizer.pick(Array.from(options));
        for (var i = 0, c = options.length; i < c; i++) {
            var option = options[i];
            option.selected = option.value == randomOption.value;
        }
        return randomOption.value;
    }
    function fillRadio(element) {
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        element.dispatchEvent(evt);
        return element.value;
    }
    function fillCheckbox(element) {
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        element.dispatchEvent(evt);
        return element.value;
    }
    function fillEmail(element) {
        if (config.randomizer === null) {
            return undefined;
        }
        var email = config.randomizer.email();
        element.value = email;
        return email;
    }
    utils_1.configurable(formFillerGremlin, config);
    return formFillerGremlin;
}
exports.formFiller = formFiller;
